import { render } from "./IngressClass.vue?vue&type=template&id=d6680c46"
import script from "./IngressClass.vue?vue&type=script&lang=js"
export * from "./IngressClass.vue?vue&type=script&lang=js"

import exportComponent from "../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__